/**
 * Scripts for Alzheimer's Society Engaging Networks templates
 */

declare global {
  interface Window {
    EngagingNetworks: {
      validators: ENValidator[];
    };
    enVGSFields?: Record<string, { css: Record<string, string | Record<string, string>> }>;
    jQuery?: (selector: string) => {
      animate: (properties: Record<string, number>, duration: number) => void;
    };
    onENValidateSetupCompleteArray: Array<() => void>;
    pageJson: { campaignId: number; locale: string; pageType: ENActionType };
  }
}

import { accordions } from './scripts/accordion';
import { backgroundImage } from './scripts/background';
import { daisychainActions } from './scripts/daisychain';
import { mpThumbnails } from './scripts/email-to-target';
import { mobileSkipToFormButton, sideBySideElements, vgsCardFieldStyles } from './scripts/forms';
import { heroTopRowHeight } from './scripts/hero';
import { mobileShareButton } from './scripts/share';
import { survey } from './scripts/surveys';
import { ENActionType } from './scripts/types/en-action-type';
import { ENValidator } from './scripts/types/en-validator';
import {
  shortenLongValidationMessages,
  stripHtmlFromValidationMessages,
} from './scripts/validation';
import { progressBarWidget } from './scripts/widgets';

// Import styles so they are included in the build
import './styles/main.scss';

// Run immediately - function checks whether page has loaded and if not, it will run again until it finds the background image settings or page finishes loading
backgroundImage();

// Run immediately - functional code will actually run when ENvalidate setup is complete
stripHtmlFromValidationMessages();
shortenLongValidationMessages();

// Functions that run on page load
document.addEventListener('DOMContentLoaded', () => {
  accordions();
  mobileShareButton(); // set up mobile share button before daisy chain actions in case there are share buttons in the daisychain
  daisychainActions();
  heroTopRowHeight();
  mobileSkipToFormButton();
  mpThumbnails();
  progressBarWidget();
  sideBySideElements();
  survey();
  vgsCardFieldStyles();
});
